import { CountUp } from '../TickerBlock/countUp';

window.onload = function () {

    var rounded_total;
    const tickerDateSt = document.getElementById('Content_TickerStartDate').value;
    const tickerDate = new Date(tickerDateSt);
    const tickerDateIsoFormatSt = tickerDate.toISOString().replace('Z', '').substring(0, 10).concat("T00:00:00");
    const tickerDateIsoFt = new Date(tickerDateIsoFormatSt);
    const tickeramt = this.document.getElementById('Content_TickerStartAmount').value;
    const tickerAvgtickRate = this.document.getElementById('Content_AverageTickRate').value;

    var calculateAmount = () => {
        var sec = Math.abs(new Date() - tickerDateIsoFt) / 1000;
        var total = (sec * parseFloat(tickerAvgtickRate)) + parseFloat(tickeramt);
        rounded_total = (Math.floor(total) + Math.floor(100 * (total - Math.floor(total))) / 100).toFixed(2);
    }

    calculateAmount();

    var continueouscountUpOptions = {
        startVal: 0,
        decimalPlaces: 2, // number of decimal places (0)
        duration: 1, // animation duration in seconds (2)
        useGrouping: true, // example: 1,000 vs 1000 (true)
        useEasing: true, // ease animation (true)
        prefix: "$" // text prepended to result
    };
    const Continueouscounter = new CountUp('odometer', rounded_total, continueouscountUpOptions);

    var updateCounter = () => {
        calculateAmount();
        Continueouscounter.update(rounded_total);
    }
    var continueCounter = () => {
        Continueouscounter.start();
        this.setInterval(updateCounter,500);
    }

    Continueouscounter.start(() => continueCounter());
}
